import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, CreditCardIcon, LandmarkIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage relative isolate overflow-hidden pb-16 pt-12 sm:pb-20 sm:pt-16" data-id="element-128" data-mp="129qwbqwlhzqi">
      <div className="pointer-events-none absolute -left-24 top-24 -z-10 h-72 w-72 rounded-full bg-violet/25 blur-3xl" data-id="element-129" data-mp="xa4j3hgrojhp" />
      <div className="pointer-events-none absolute -right-20 top-1/3 -z-10 h-72 w-72 rounded-full bg-magenta/20 blur-3xl" data-id="element-130" data-mp="s9zwrat6gujk" />
      <div className="absolute right-0 top-0 -z-10 h-80 w-80 border-b border-l border-gold/25" data-id="element-131" data-mp="neawf59c39m7" />
      <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-132" data-mp="3d2tm12xxw8bd">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-petrolDark px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-133" data-mp="381e2xgfbobvm">
          <LandmarkIcon className="h-4 w-4" data-id="element-134" data-mp="39cpc2rohrf1b" /> Megapack Gestión Cultural Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.04] text-white sm:text-6xl md:text-7xl" data-id="element-135" data-mp="3eb90qzugz4xd">
          Del diagnóstico al evento.<br data-id="element-136" data-mp="2vjzqgocvkc4q" />
          <span className="text-gold" data-id="element-137" data-mp="2vjg6z37ktfol">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto my-4 max-w-2xl sm:my-6" data-id="element-138" data-mp="2hk84o1g49rg6">
          <img src={productImage} alt="Megapack Gestión Cultural Listo: seis tomos, cuatro bonos y dos módulos premium" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(122,63,242,.35)]" data-id="element-139" data-mp="s3umzlkswo5c" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-140" data-mp="deq6c8tnmrzc">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <span key={item} className="rounded-full border border-lineDark bg-petrolDark px-3 py-2" data-id="element-141" data-mp="162ued0zp7h57">
              {item}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-142" data-mp="x1eevoaf8zfr">
          <Button onClick={scrollToPricing} arrow data-id="element-143" data-mp="x031qxv36fbz">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-144" data-mp="3lu03r3mln90s">
          <span className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="3hqk6q66mb6nk"><ShieldCheckIcon className="h-4 w-4 text-gold" data-id="element-146" data-mp="1x9kv8ohov8i9" /> Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="1x7htx8b35sy8"><LockIcon className="h-4 w-4 text-gold" data-id="element-148" data-mp="21bxyn68yqubv" /> Pago seguro</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-149" data-mp="26a999j7318v5"><CreditCardIcon className="h-4 w-4 text-gold" data-id="element-150" data-mp="268g468c4awp9" /> Mercado Pago</span>
        </div>

        <p className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-mutedDark" data-id="element-151" data-mp="2b2ai0v51khgf">
          <BadgeCheckIcon className="h-4 w-4 text-gold" data-id="element-152" data-mp="2fz0znmwhvl3y" />
          <ZapIcon className="h-4 w-4 text-gold" data-id="element-153" data-mp="2kynd9xg8j3da" /> Para docentes de Gestión Cultural de toda Argentina
        </p>
      </div>
    </section>;
}